var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleOutline = function SvgCheckCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.816 7c.314 0 .615.14.837.39s.347.59.347.943-.125.692-.347.941l-6.2 6.989c-.208.234-.454.42-.726.547a2 2 0 0 1-.855.19h-.039a2 2 0 0 1-.87-.216 2.2 2.2 0 0 1-.722-.584l-1.91-2.237a1.43 1.43 0 0 1-.331-.95c.003-.175.037-.348.1-.508.062-.16.151-.306.263-.427s.245-.216.39-.28a1.07 1.07 0 0 1 .905.02q.215.107.38.297l1.835 2.158 6.107-6.882c.221-.25.523-.391.836-.391"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0m0 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2",
    clipRule: "evenodd"
  })));
};
export default SvgCheckCircleOutline;